import $ from "jquery";
import CookieConsent from "@alpaga/cookie-consent";
import "./../styles/main.scss";
require("jquery.scrollto");
// require("./helpers/ihavecookies");
$(document).ready(function () {
    var CookieConsentNode = new CookieConsent({
        locale: "fr",
        cookies: {
            'necessary': {
                name: "necessary",
                disabled: true,
                value: true,
                title: "Cookies nécessaires",
                description: "Les cookies nécessaires permettent de rendre un site Web utilisable en activant des fonctions de base telles que la navigation dans les pages et l'accès à des zones sécurisées du site. Le site Web ne peut pas fonctionner correctement sans ces cookies.",
                "function": function () { },
                cookies: [
                    {
                        name: "CookieConsent",
                        provider: "cookieconsent.extension",
                        purpose: "Stocke l'état de consentement des cookies de l'utilisateur pour le domaine actuel",
                        expiry: "1 an",
                        type: "HTTP"
                    },
                ]
            },
            analytics: {
                name: "analytics",
                value: true,
                title: "Analytics Cookies",
                "function": function () {
                },
                description: "Les cookies analytiques aident les propriétaires de sites Web à comprendre comment les visiteurs interagissent avec les sites Web en collectant et en rapportant des informations de manière anonyme.",
                cookies: [
                    {
                        name: "_ga",
                        provider: "Google",
                        purpose: "Enregistre un identifiant unique utilisé pour générer des données statistiques sur la manière dont le visiteur utilise le site Web.",
                        expiry: "2 ans",
                        type: "HTTP"
                    },
                    {
                        name: "_gat",
                        provider: "Google",
                        purpose: "Utilisé par Google Analytics pour limiter le taux de demandes",
                        expiry: "1 jour",
                        type: "HTTP"
                    },
                    {
                        name: "_gid",
                        provider: "Google",
                        purpose: "Enregistre un identifiant unique utilisé pour générer des données statistiques sur la manière dont le visiteur utilise le site Web.",
                        expiry: "1 jour",
                        type: "HTTP"
                    }
                ]
            }
        }
    });
    // CookieConsentNode.init();
    // const viewCookieBannerButton = document.querySelector(".view-cookie-banner");
    // if (viewCookieBannerButton !== void 0) {
    //     viewCookieBannerButton.addEventListener("click", (e) => {
    //         e.preventDefault();
    //         CookieConsentNode.showDetails();
    //     });
    // }
    $("body").on("click", "a[href^='#goto-']", function (e) {
        e.preventDefault();
        var node = $(e.currentTarget).attr("href").replace("goto-", "");
        var posY = $(node).offset().top - $("#main-header").height();
        if (posY >= 0) {
            $.scrollTo(posY, 400);
        }
    });
    $('body').on("click", ".shared-item", function (e) {
        e.preventDefault();
        window.open($(e.currentTarget).attr("href"), "", "width=500,height=350");
    });
    $("body").on("click", "#menu-switcher a", function (e) {
        e.preventDefault();
        $("#nav-main").toggleClass("show-menu");
        $(e.currentTarget).toggleClass("show-menu");
    });
    $("body").on("click", ".goTo", function (e) {
        var elm = $(e.currentTarget).attr("href");
        var posY = $(elm).offset().top - $("#main-header").height();
        $.scrollTo(posY, 400);
    });
});
